'use client';

import { cx } from '@onbeam/business-styled-system/css';
import { center } from '@onbeam/business-styled-system/patterns';
import { ShaderBannerProps } from './ShaderBanner.types';
import { ShaderBannerAnimation } from './ShaderBannerAnimation';
import { useRef } from 'react';
import { useInView } from 'motion/react';

export const ShaderBanner = ({
  className,
  preset,
  children,
  ...props
}: ShaderBannerProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const isInView = useInView(ref, {
    margin: '500px 0px 500px 0px',
  });

  return (
    <div
      ref={ref}
      className={cx(
        'light',
        center({
          flexDirection: 'column',
          position: 'relative',
          w: 'full',
          h: '[32.5rem]',
          rounded: 'md',
          textAlign: 'center',
          overflow: 'hidden',
          color: 'mono.primaryFg',
          gap: '6',
          p: '5',
          md: {
            h: '[28.75rem]',
          },
        }),
        className,
      )}
      {...props}
    >
      {isInView && <ShaderBannerAnimation preset={preset} />}
      {children}
    </div>
  );
};
